import { DateRangeEnum } from "types/topicflow";

export enum OverviewExtraDateRangeEnum {
  custom = "custom dates",
}

export type OverviewDateRangeType = OverviewExtraDateRangeEnum | DateRangeEnum;
